import React from 'react';
import { Modal, Typography, Card, Space, Button, Avatar } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text, Paragraph } = Typography;

const ThankYouModal = ({ visible, onClose, subscription }) => {
  const { t } = useTranslation();

  const planName = subscription?.getPlanDisplayName();
  const handleLetsGo = () => {
    onClose();
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={null} // Make modal non-closable
      footer={null}
      width={900} // Make modal wider
      centered
      closable={false} // Remove close button
      maskClosable={false} // Prevent closing by clicking outside
      style={{ top: 20 }}
      styles={{ body: { padding: 0 } }} // Remove default padding for hero treatment
    >
      <div>
        {/* Hero Section - Similar to Subscription page */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '30px 32px',
          textAlign: 'center'
        }}>
          <Avatar 
            src="https://img.icons8.com/plasticine/100/heart-with-pulse.png" 
            size={80} 
            style={{ marginBottom: '16px' }}
          />
          
          <Title level={2} style={{ 
            color: 'white', 
            margin: '12px 0',
            fontWeight: '600'
          }}>
            {t('subscription_thank_you.title')}
          </Title>

          <Paragraph style={{ 
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)',
            marginBottom: '10px',
            lineHeight: '1.6'
          }}>
            {t('subscription_thank_you.subtitle')}
          </Paragraph>
        </div>

        {/* Content Section */}
        <div style={{ padding: '32px', marginTop: '20px' }}>
          {/* Subscription Info Card */}
          <Card 
            style={{ 
              marginBottom: '24px',
              border: '1px solid #f0f0f0',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
            styles={{ body: { padding: '24px' } }}
          >
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CrownOutlined style={{ 
                  fontSize: '24px', 
                  color: 'purple',
                  marginRight: '12px',
                  marginBottom: '5px'
                }} />
                <Text strong style={{ fontSize: '18px', color: '#4c1d95' }}>
                  {planName}
                </Text>
              </div>
              
              <Text style={{ color: '#595959', display: 'block', textAlign: 'center', fontSize: '16px' }}>
                {t('subscription_thank_you.plan_message', { plan: planName })}
              </Text>
            </Space>
          </Card>

          {/* Call-to-Action Button */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Button 
              type="primary" 
              size="large"
              onClick={handleLetsGo}
              style={{ 
                backgroundColor: 'var(--upgrade-color)', 
                borderColor: 'var(--upgrade-color)',
                height: '48px',
                fontSize: '16px',
                fontWeight: '600',
                padding: '0 32px'
              }}
            >
              {t('subscription_thank_you.lets_go_button')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ThankYouModal; 